import Vue from 'vue'
import DialogMixin from '@/components/shared/DialogMixin'

Vue.mixin({
  methods: {
    $hasPermission(neededPermissions) {
      const noPermissions = neededPermissions === undefined
      const hasPermission = neededPermissions?.every((permission) =>
        this.$store.state.fiiAuth.identity?.roles?.includes(permission)
      )
      return noPermissions || hasPermission
    },
  },
})

Vue.mixin(DialogMixin)
